var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23c5.851 0 11-5.149 11-11.5s-5.149-11.5-11-11.5c-6.851 0-12 5.149-12 11.5s5.149 11.5 12 11.5z",
    stroke: "#525252",
    strokeWidth: 0.5,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1l-2 2-1 1m8.45 6.095s-1.522-1.341-3.087-2.142c-1.564-.801-3.821-1.022-3.821-1.022m-3.947 2.179s-.236 1.846 0 3.361l1.045 3.359m3.98 2.314s2.221.134 3.916-1.092c1.698-1.222 2.524-2.914 2.524-2.914m-19.796-3.604s.658-1.558 2.093-2.537c1.436-.978 3.464-1.296 3.464-1.296m-2.034-4.634c1.659-.436 3.224 2.103 3.224 2.103m-6.003 10.461s1 1.861 2.492 2.641c1.491.778 3.336.879 3.336.879m5.046 3.022l.738 1.78m-4.099-1.951l-.783 2",
    id: "Shape",
    strokeWidth: 0.652,
    stroke: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.075l-4.008 2.925-3.992-2.989 1.669-3.982 4.97-.028 1.362 4.075zm-.364 14.925l1.364-4.075-4.008-2.925-3.992 2.989 1.669 3.981 4.967.03zm-13.46-12.271h1.904l.848 5.809-1.468 1.603s-.861-.913-1.305-3.342c-.36-1.966.021-4.07.021-4.07zm21.815-2.466l-3.106 2.528.957 5.278 2.805-.813s.424-1.758.192-3.828c-.178-1.539-.849-3.164-.849-3.164zm-7.991-5.263l4-.578s-.618-.401-2.001-.896c-1.379-.496-1.999-.526-1.999-.526v2z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/Ball.61d1b7a9a8019e2c32cf3a55e939a6d7.svg";
export { ForwardRef as ReactComponent };